(() => {
  const mount = () => {
    const page = document.querySelector('.oral-niacinamide-foam');
    if (!page || page.dataset.quantityLayoutBound) return;
    page.dataset.quantityLayoutBound = 'true';
    // Relocate the app's own control, retaining its quantity and discount handlers.
    const place = () => {
      const block = page.querySelector('kaching-bundle .kaching-bundles__block');
      const active = block?.querySelector('.kaching-bundles__bar--selected .kaching-bundles__quantity-selector');
      if (!block || !active) return;
      let footer = block.querySelector('.n8x-kaching-quantity');
      if (!footer) {
        footer = document.createElement('div');
        footer.className = 'n8x-kaching-quantity';
        const label = document.createElement('label');
        label.textContent = 'Quantity';
        label.htmlFor = 'niacinamide-bottle-quantity';
        footer.append(label);
        block.append(footer);
      }
      footer.querySelectorAll('.kaching-bundles__quantity-selector').forEach(control => {
        if (control !== active) control.remove();
      });
      active.querySelector('input').id = 'niacinamide-bottle-quantity';
      footer.append(active);
    };
    new MutationObserver(place).observe(page, {childList:true, subtree:true});
    place();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
})();